import i18nRemote from '../plugins/i18next-remote'
import flowSettings from './config/settings'

import '../../static/remote/intro.mp4'
import '../../static/remote/intro-desktop.mp4'

const remoteStatus = {
  frameHolder: null,
  remoteStatusHolder: document.createElement('div'),
  device: null,
  host: null,
  remoteConfig: flowSettings.remoteConfig,
  showConnected: false,

  openFrame (frameHolder, device, host, language, isPlayground) {
    if (language) {
      i18nRemote.changeLanguage(language)
    }
    this.frameHolder = frameHolder
    this.device = device
    this.host = host
    this.insertStatusBar()
  },

  closeFrame () {
    if (!this.remoteStatusHolder.parentNode) return
    this.frameHolder.classList.remove('show-module-remote')
    this.frameHolder.classList.remove('show-remote-loader')
    this.frameHolder.classList.remove('remove-bg-overlay')
    this.remoteStatusHolder.parentNode.removeChild(this.remoteStatusHolder)
  },
  insertConnectingText () {
    const connectingNode = document.createElement('div')
    connectingNode.classList.add('remote-status-connecting')
    connectingNode.innerHTML = `${i18nRemote.t('connecting_to', { domain: this.remoteConfig.notificationDomain || flowSettings.partnerName })}`
    connectingNode.innerHTML += `<span class="dots">.</span>`
    this.remoteStatusHolder.appendChild(connectingNode)
  },
  insertConnectedText () {
    const connectedNode = document.createElement('div')
    connectedNode.classList.add('remote-status-connected')
    connectedNode.innerHTML = `${i18nRemote.t('connected_to', { ltag: '<span class="connected-text">', rtag: '</span>' })}`
    connectedNode.innerHTML += ` <span class="brand-name">${this.remoteConfig.notificationDomain || flowSettings.partnerName}</span>`

    this.remoteStatusHolder.appendChild(connectedNode)
    setTimeout(() => {
      this.remoteStatusHolder.classList.add('show-connected-brand-name')
    }, 1800)
  },
  showConnectedNotification () {
       if (this.showConnected) return

       setTimeout(() => {
        this.remoteStatusHolder.classList.add('show-connected')
        this.insertConnectedText()
       }, 1000)

       this.showConnected = true
  },
  insertStatusBar () {
    this.remoteStatusHolder.classList.add('remote-status')

    this.insertConnectingText()

    this.frameHolder.appendChild(this.remoteStatusHolder)
  }

}

export default remoteStatus



// WEBPACK FOOTER //
// ./src/partners/remote-status.js